<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
            <div class="col-md-1 d-flex pe-4 justify-content-end">
                <div class="button-back" [routerLink]="['../schedules']">
                    <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
                </div>
            </div>
            <div class="col-md-6 pb-2">
                <h2 class="col pb-2 m-0 title">
                    {{"SCHEDULELOGS" | translate}}
                </h2>
                <h6 class="col subtitle">
                    {{"SCHEDULELOGS_SUBTITLE" | translate}}
                </h6>
            </div>
        </div>
        <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
            <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
            <div class="button-wrapper pe-2">
                <div class="button">
                    <img alt="Date" src="assets/core/table-button/date.svg" />
                    <div class="button-text" (click)="toggleModal()"
                        [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                        <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                            {{ selectedDate }}
                        </ng-container>
                        <ng-template #noDateSelected>
                            <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                        </ng-template>
                    </div>
                    <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit" src="assets/device/x.svg"
                        (click)="clearDates()" />
                </div>
            </div>
            @if (isDatepickerOpen) {
            <div class="overlay" (click)="toggleModal()"></div>
            <app-datepicker [scale]="1.2" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
            }
            <app-search class="pe-2" placeholder="{{ 'SETTINGS_SEARCHBYNAME' | translate }}"
                (searchChange)="searchChange($event)">
            </app-search>
        </div>
        <div class="row g-0 m-0 pt-3">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"TYPE" | translate}}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"SCHEDULENAME" | translate}}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"STARTTIME" | translate}}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"DEVICESETUP_REGION" | translate}}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"DEVICESETUP_AREA" | translate}}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "PROCESSED" | translate }}</span>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of data; let i=index" (click)="handleRowClick(row.id)">
                        <td></td>
                        <td>
                            <span>{{ row.type }}</span>
                        </td>
                        <td>
                            <span>{{ row.scheduleName }}</span>
                        </td>
                        <td>
                            <span [title]="row.startTime | date: 'dd MMM yyyy, h:mm:ss a'">{{ row.startTime | date: "dd
                                MMM yyyy, h:mm:ss a" }}</span>
                        </td>
                        <td>
                            <span>{{ row.assetTypeNames?.join(', ') || '/' }}</span>
                        </td>
                        <td>
                            <span>{{
                                row.regionNames?.join(', ') || '/'
                                }}</span>
                        </td>
                        <td>
                            <span>{{
                                row.areaNames?.join(', ') || '/'
                                }}</span>
                        </td>
                        <td>
                            <div *ngIf="row.successfullyProcessed != null && row.processed != null"
                                class="progress custom-progress position-relative">
                                <div class="progress-bar custom-progress-bar"
                                    [style.width.%]="row.processed !== 0 ? (row.successfullyProcessed / row.processed) * 100 : 0"
                                    [ngClass]="{
                                    'processed': row.successfullyProcessed === row.processed,
                                    'processing': row.successfullyProcessed !== null
                                                    && row.successfullyProcessed < row.processed
                                                    && row.successfullyProcessed !== 0
                                    }" aria-valuemin="0" [attr.aria-valuemax]="row.processed"
                                    [attr.aria-valuenow]="row.successfullyProcessed"></div>

                                <div *ngIf="row.successfullyProcessed != null && row.processed != null"
                                    class="progress-text position-absolute top-50 start-50 translate-middle custom-progress-text">
                                    {{ row.successfullyProcessed }} / {{ row.processed }}
                                </div>
                            </div>
                        </td>
                        <td>
                            @if(authService.isAuthorized([PermissionsEnum.Scheduler_monitoring_download])){
                            <svg-icon alt="More" src="assets/settings/more-icon.svg" class="more-icon"
                                (click)="setActiveRow(i); $event.stopPropagation()"></svg-icon>
                            <div *ngIf="activeRow === i" class="positioning">
                                <div class="overlay-light" (click)="setActiveRow(null); $event.stopPropagation()"></div>
                                <div class="dropdown-button p-2">
                                    <div class="dropdown-button-menu p-0 m-0">
                                        <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                                            (click)="downloadReport(row.id!); $event.stopPropagation()">
                                            <svg-icon alt="Download" src="assets/core/table/download.svg"></svg-icon>
                                            <span class="ps-2 item-title">{{"DOWNLOADREPORT" | translate}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfReminders" [pageSize]="pageSize"
            [currentPage]="currentPage" (pageChange)="pageChange($event)">
        </app-pagination>
    </div>
</div>
